import React, { useEffect } from 'react';
import { UpdateConfirmationModal, UpdateDepositForm } from 'components';
import { useApp, useUpdateDeposit } from 'providers';
import { Alert, Container, Button } from '@groupelacentrale/contact-storybook';
import { useLocation } from 'react-router-dom';
import { Tracking, TRACKING_PAGES } from 'api';

const trackingFunctions = {
  part: {
    version: TRACKING_PAGES.MODIFICATION_VERSION,
    equipements: TRACKING_PAGES.MODIFICATION_DESCRIPTION,
    photos: TRACKING_PAGES.MODIFICATION_PHOTOS,
    contact: TRACKING_PAGES.MODIFICATION_COORDONEES,
    prix: TRACKING_PAGES.MODIFICATION_PRIX,
  },
  pro: {
    version: TRACKING_PAGES.MODIFICATION_VERSION_PRO,
    equipements: TRACKING_PAGES.MODIFICATION_DESCRIPTION_PRO,
    photos: TRACKING_PAGES.MODIFICATION_PHOTOS_PRO,
    contact: TRACKING_PAGES.MODIFICATION_COORDONEES_PRO,
    prix: TRACKING_PAGES.MODIFICATION_PRIX_PRO,
  },
};

export const UpdateDepositPage: React.FC = () => {
  const { classified, error, updated, handleReturn } = useUpdateDeposit();
  const { user } = useApp();
  const { hash } = useLocation();

  useEffect(() => {
    if (updated) {
      setTimeout(() => {
        handleReturn();
      }, 2500);
    }
  }, [updated, user, handleReturn]);

  useEffect(() => {
    if (hash) {
      const hashValue = hash.substr(1);
      const functions = user!.isPro ? trackingFunctions.pro : trackingFunctions.part;
      if (functions[hashValue as keyof typeof functions]) {
        Tracking.sendPage(functions[hashValue as keyof typeof functions]());
      }
    }
  }, [hash, user]);

  if (error || !classified) {
    return (
      <Container shadowed paddings="mediumP" backgroundColor="bgWhite" className="error-actions container-solo ">
        <Alert type="error">{error}</Alert>
        <span className="btns">
          <Button label="Retour" theme="quaternary" type="button" onClick={handleReturn} />
          <Button label="Valider les modifications" theme="primary" type="button" disabled />
        </span>
      </Container>
    );
  }

  return (
    <>
      <UpdateDepositForm />
      <UpdateConfirmationModal isOpen={updated} />
    </>
  );
};
